(() => {
  const dialog = document.getElementById('PaZeSearch');
  const opener = document.querySelector('[data-paze-search-open]');
  if (!dialog || !opener || !dialog.showModal) return;
  const input = dialog.querySelector('[name="q"]');
  const results = dialog.querySelector('[data-paze-search-results]');
  const status = dialog.querySelector('[data-paze-search-status]');
  let timer, request, revision = 0;
  opener.addEventListener('click', event => {
    event.preventDefault();
    dialog.showModal();
    document.documentElement.classList.add('paze-search-is-open');
    input.focus();
  });
  dialog.querySelector('[data-paze-search-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    const box = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => {
    clearTimeout(timer); request?.abort(); revision++;
    results.removeAttribute('aria-busy'); status.textContent = '';
    document.documentElement.classList.remove('paze-search-is-open');
    opener.focus();
  });
  input.addEventListener('input', () => {
    clearTimeout(timer); request?.abort();
    const current = ++revision;
    results.replaceChildren();
    results.removeAttribute('aria-busy');
    const query = input.value.trim();
    status.textContent = '';
    if (!query) return;
    timer = setTimeout(async () => {
      request = new AbortController();
      status.textContent = 'Searching…'; results.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(dialog.dataset.suggestUrl, location.origin);
        url.search = new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'6',section_id:'paze-predictive-search'}).toString();
        const response = await fetch(url, {signal:request.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (current !== revision || !dialog.open) return;
        const content = page.querySelector('[data-paze-product-results]');
        if (!content) throw new Error('Missing search results');
        results.replaceChildren(content);
        const count = results.querySelectorAll('li').length;
        status.textContent = count ? `${count} matching product${count === 1 ? '' : 's'}.` : '';
      } catch (error) {
        if (error.name !== 'AbortError' && current === revision) status.textContent = 'Search is temporarily unavailable. Press Search to try the full product search.';
      } finally {
        if (current === revision) results.removeAttribute('aria-busy');
      }
    }, 250);
  });
})();
